import React, {forwardRef, useMemo, useState} from 'react'
import moment from 'moment'
import './CurrentTimeIndicator.scss'

const CurrentTimeIndicator = forwardRef((props, ref) => {
  return <div ref={ref} className="c-current-time-indicator"></div>
})

export default CurrentTimeIndicator
